import React, {Component} from 'react'
import Jumbotron from '../components/Jumbotron'
import DemoContents from '../components/DemoContents'
import image from '../assets/tableGame.png'

const styles = {
  img: {
    width: 341,
    height: 490,
    border: 0,
    padding: 0,
    margin: 0,
    cursor: 'pointer'
  },
}

const ClickImage = ({classes, onClick}) =>
  <img src={image} alt="Click to load" width={341} height={490} onClick={onClick} style={styles.img} />

class OnClick extends Component {
  state = {
    iFrame: null,
    image: <ClickImage onClick={() => this.handleClick()} />
  }

  handleClick = () => {
    console.log('CLICKED')
    this.setState({
      iFrame: window.amigoGames.openKeepEmPoker(true),
      image: null
    })
  }
  render() {
    const {iFrame, image} = this.state
    return (
      <div>
        <Jumbotron
          variant="light"
          type="playOnDemand"
          message="gameLoadsAfterAnEvent"
        />
        <DemoContents
          variant="dark"
          image={image}
          iFrameContents={iFrame}
        />
      </div>
    )
  }
}

export default OnClick



// WEBPACK FOOTER //
// ./src/pages/OnClick.js